<div class="card_inner">
  <div *ngIf='dataLoading' class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>

  <div class="table-responsive" *ngIf="!dataLoading">
    <table class="table custom-table products-list">
      <thead>
        <tr>
          <th>{{"productEvaluationTasks.productName"|translate}}</th>
          <th>{{"technicalEvaluation.overallEvaluation"|translate}}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (record of recordsData.data; track record.id) {
        <tr>
          <td>
            <div class="name-with-image-rounded">
              <div class="image-rounded">
                <div class="image">
                  <img *ngIf="record.productImage" [src]="record.productImage"
                    (error)='record.productImage  = "assets/images/no_logo.png"'>
                  <span *ngIf="!record.productImage">
                    {{ record.productName| shortName }}
                  </span>
                </div>
              </div>
              <div class="name">
                <h5 [matTooltip]="record.productName">
                  {{ record.productName| truncateText:50 }}
                </h5>
              </div>
            </div>
          </td>
          <td>
            <span class="badge_state orange_ff" *ngIf="!record.isEvaluated">
              {{"productEvaluationTasks.notEvaluatedYet" | translate}}
            </span>
            <ng-container *ngIf="record.isEvaluated">
             <span dir="ltr">%{{record.totalScore}}</span>
            </ng-container>

          </td>
          <td>
            <div class="btn-actions">
              <button mat-raised-button (click)="openForm(record.id)" color="primary"
                *ngIf="record.canStartEvaluation">
                {{"productEvaluationTasks.startEvaluation" | translate}}
              </button>
              <button mat-raised-button (click)="openForm(record.id)" color="primary"
                *ngIf="record.canUpdate">
                {{"productEvaluationTasks.editEvaluation" | translate}}
              </button>
              <button mat-raised-button color="primary" *ngIf="record.canviewProductEvaluationResult"
                class="mat-primary-light" (click)="selectedRecordId = record.id">
                {{"productEvaluationTasks.viewEvaluationResult" | translate}}
              </button>
            </div>
          </td>
        </tr>
        }
      </tbody>

    </table>
  </div>
</div>

<app-product-evaluation-result *ngIf="selectedRecordId" (close)="selectedRecordId = false;"
  [selectedRecordId]="selectedRecordId" [taskId]="taskId"></app-product-evaluation-result>
